var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-table',{attrs:{"data":_vm.table.data,"columns":_vm.table.columns,"thead-classes":"text-primary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }